import colors from '../ui-kit/themes/colors';

export const CHECKIN_ELIGIBLE_STATUS_VALUE = 1;
export const CHECKIN_TOO_EARLY_STATUS_REASONS = [1, 2];
export const CHECKIN_PRE_CHECKED_IN_STATUS_VALUES = [4, 5];

export const CHECK_IN_MESSAGES = {
  available: {
    description: 'Mobile pre check-in is available now!',
    color: colors.nightSkyBlack[80]
  },
  unavailable: {
    description: 'Mobile pre check-in will be available 48 hours prior to your reservation.',
    color: colors.nightSkyBlack[80]
  },
  successful: {
    title: 'Mobile pre check-in successful!',
    description: 'Check your email to see more information',
    color: colors.deepForestGreen[100]
  },
  invalid: {
    title: 'Your reservation is not valid for mobile pre check-in',
    description: 'Please check-in at the lodge when you arrive',
    color: colors.errorOrange
  },
  mobile: {
    description: 'Mobile pre check-in will be available 48 hours before you arrive via email and SMS',
    color: colors.nightSkyBlack[80]
  }
};

export const ICON_STYLES = {
  size: '21px',
  color: colors.preciousStoneBlue[100]
};
